import React from "react";
import "./NotFound.css";

function ErrorPage() {
  const pageHome = () => {
    window.location.href = "https://etranssolutions.com";
  };

  return (
    <div id="404Error" className="popSc">
      <div className="popBo">
        <img src="./host-images/404Error.gif" width="100%" loading="lazy" />
        <h2>We Are Sorry...</h2>
        <p>
          This page does not exist or may be fall a sleep ! We suggest you back
          to Home..
        </p>
        <div>
          <button className="popBtn btnmarg" onClick={pageHome}>
            <svg
              viewBox="0 0 1024 1063.18"
              xmlns="http://www.w3.org/2000/svg"
              style={{ fill: "#fff" }}
            >
              <path d="M979.478 564.72L503.986 168.345 28.494 564.587 0 530.394l503.986-420.018 503.986 420.152zM852.59 978.15H604.16V651.36H403.812v326.79h-248.43V425.19h44.52v508.438h159.39v-326.79h289.39v326.79H808.07V425.19h44.522z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
export default ErrorPage;
